import { GenericSpiderChart } from "@/../types";
import { FrontEndModel } from "../FrontEndModel";
export class SpiderChartModel extends FrontEndModel implements GenericSpiderChart{
	power: number = -1;
	agility: number = -1;
	acceleration: number= -1;
	speed: number= -1;
	recovery: number= -1;
}